import { Typography } from '@recruit-robin/robin-theme/web-components';
import { LinkBroken } from '@recruit-robin/robin-theme/web-icons';
import { useContext } from 'react';

import type { NoVacanciesFoundProps } from './NoVacanciesFound.types';

import { LocalizationContext } from 'shared/legacy/contexts/LocalizationContext/LocalizationContext';
import { useStyles } from './NoVacanciesFound.styles';

export const NoVacanciesFound = ({ onCreateJob }: NoVacanciesFoundProps) => {
  const classes = useStyles();
  const { dictionary } = useContext(LocalizationContext);

  return (
    <div css={classes.root}>
      <div css={classes.content}>
        <div css={classes.iconWrapper}>
          <LinkBroken size={16} color={(v) => v.neutral.variant[70]} />
          <Typography variant={(v) => v.heading[6]} color={(v) => v.neutral.variant[70]}>
            {dictionary.noVacanciesFound}
          </Typography>
        </div>
        <Typography variant={(v) => v.supporting.helper} css={classes.description}>
          {dictionary.checkYourAtsConnection}{' '}
          <span css={classes.link} onClick={() => window.open(dictionary.learnMoreLink, '_blank')}>
            {dictionary.learnMore}
          </span>
          .<br />
          {dictionary.youCanAlso}{' '}
          <span css={classes.link} onClick={onCreateJob}>
            {dictionary.createNewJob}
          </span>{' '}
          {dictionary.inRobin}.
        </Typography>
      </div>
    </div>
  );
};
